/**
 * While moving: on their feet and going somewhere.
 *
 * The condition behind every perk that rewards staying mobile. Falling does not count, because
 * `moving` is movement under the character's own power and a perk should not pay out for a drop.
 */

import type { EffectCondition } from '@/sim/effects/effectConditionContract';

export const WHILE_MOVING = {
  id: 'whileMoving',
  label: 'while moving',
  holds: (moment) => moment.moving && !moment.downed,
} as const satisfies EffectCondition;
